function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcLogicGAppAttention = function SvgIcLogicGAppAttention(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    x: 0,
    y: 0,
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_10755",
    d: "M10 0C4.5 0 0 4.5 0 10s4.5 10 10 10 10-4.5 10-10S15.5 0 10 0m-.9 5.3c0-.5.4-.9.9-.9s.9.4.9.9v5.9c0 .5-.4.9-.9.9s-.9-.4-.9-.9zm.9 10.9c-.7 0-1.3-.6-1.3-1.3s.6-1.3 1.3-1.3 1.3.6 1.3 1.3-.6 1.2-1.3 1.3",
    style: {
      fill: "#d7ddf3"
    }
  }));
};
export default SvgIcLogicGAppAttention;